<template>
  <div>
    <section
      :style="customStyle"
      class="gallery-modal">
      <div class="gallery-modal-header">
        <div class="title-container">
          <slot name="header-title"></slot>
        </div>
        <div class="actions">
          <slot name="header-actions"></slot>
          <button
            class="btn-close"
            @click.stop="dismissAction">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div class="gallery-modal-body">
        <slot name="body"></slot>
      </div>
    </section>
    <div
      :class="{'hide' : hideOverlay}"
      class="gallery-modal-overlay"></div>
  </div>
</template>

<script>
export default {
  props: {
    customStyle: {
      type: Object,
      default: null,
    },
    dismissAction: {
      type: Function,
      default: () => this.$store.dispatch('setGalleryActiveModal', null),
    },
    hideOverlay: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-modal {
  position: fixed;
  width: 500px;
  height: 90vh;
  background: #FFF;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 20px;
  border-radius: 0.25rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  z-index: 102;
  .gallery-modal-header {
    display: flex;
    flex-flow: row;
    width: 100%;
    align-items: center;
    padding: 10px 0;
    justify-content: space-between;
    .title-container {
      .title {
        display: flex;
        flex-flow: row;
      }
      .title-header {
        margin-left: 10px;
      }
    }
    i {
      cursor: pointer;
    }
    .actions {
      display: flex;
      flex-flow: row;
      .btn-close {
        background: transparent;
        border: none;
        outline: none;
        margin-left: 10px;
      }
    }
  }
  .gallery-modal-body {
    position: relative;
    height: calc(100% - 53px);
  }
}
.gallery-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 101;
  &.hide {
    display: none;
  }
}
</style>
